var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading && !_vm.isLoadingPrincipal)?_c('div',{attrs:{"id":"loadding-personalizado"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"div-center"}},[_c('div',{staticClass:"barra",attrs:{"id":"um"}}),_c('div',{staticClass:"barra",attrs:{"id":"dois"}}),_c('div',{staticClass:"barra",attrs:{"id":"tres"}})])
}]

export { render, staticRenderFns }